<template>
    <div class="Success">
        <div class="PageHeader">
        </div>
        <div align="center">
            <span style="font-weight: bold; font-size: 24px">HATA</span>
            <p style="font-weight: bold;margin-top: 80px">Para gönderme işlemi için bağlantıyı mobil cihazınızdan açınız.</p>
        </div>
    </div>
</template>
<script>
  import {mapGetters,mapActions} from "vuex"
  import router from "../lib/router"
  export default {
    name: "TransferError",
    components: {
    },
    data: () => ({
      successTimeout:null,
    }),
    mounted(){
      //console.log("Mounted-TransferError:",this.$route.query);
      this.setLoading(false);
      this.setTransferFlow(true);
    },
    computed:{
      ...mapGetters({
        token:'getPurchaseToken',
        authToken:'getAuthToken',
        otpInfo:'getOtpInfo',
        stkMerchants:'getStkMerchants',
        stkRoundUpInfo:'getStkRoundUpInfo',
        paybyLinkFlow:'getPaybyLinkFlow',
        purchaseResult:'getPurchaseResult',
        redirectUrl:'getRedirectUrl'
      })
    },
    methods: {
      ...mapActions({
        setLoading:'setLoading',
        completeTransaction:'completeTransaction',
        setTransferFlow:'setTransferFlow'
      })
    }
  };
</script>
<style>
    .img-result{
        width: 120px; margin-top:50px;
    }
</style>